module.exports = __webpack_public_path__ + "static/media/iconAttestation.63d0f830.svg";